var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchProvider from './FetchProvider';
import ConfigurationError, { ConfigurationErrorCode } from './errors/configurationError';
import ResolutionError, { ResolutionErrorCode } from './errors/resolutionError';
import { NamingServiceName, } from './types/publicTypes';
export class Das {
    constructor(source = {}) {
        this.name = NamingServiceName.DAS;
        this.url = source.url;
        if (source.provider) {
            this.provider = source.provider;
        }
        else if (source.url) {
            this.provider = new FetchProvider(this.name, source.url);
        }
        else {
            throw new ConfigurationError(ConfigurationErrorCode.UnspecifiedUrl, {
                method: NamingServiceName.DAS
            });
        }
    }
    isSupportedDomain(account) {
        return /.+\.bit/.test(account) && account.split('.').every(v => Boolean(v.length));
    }
    account(account) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isSupportedDomain(account)) {
                throw new ResolutionError(ResolutionErrorCode.UnregisteredDomain, {
                    domain: account,
                });
            }
            const data = yield this.provider.request({
                method: 'das_searchAccount',
                params: [
                    account,
                ]
            });
            if (!data.data) {
                throw new ResolutionError(ResolutionErrorCode.UnregisteredDomain, {
                    domain: account,
                });
            }
            data.data.account_data.records.forEach(record => {
                // the raw data is string, '300'
                record.ttl = Number(record.ttl);
                record.avatar = `https://identicons.da.systems/identicon/${account}`;
            });
            return Object.assign(Object.assign({}, data.data.account_data), { avatar: `https://identicons.da.systems/identicon/${account}` });
        });
    }
    records(account, key) {
        return __awaiter(this, void 0, void 0, function* () {
            const accountData = yield this.account(account);
            if (!key) {
                return accountData.records;
            }
            key = key.toLowerCase();
            return accountData.records.filter(record => record.key === key);
        });
    }
    addrs(account, chain) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.records(account, `address.${chain}`);
        });
    }
    accountsForOwner(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.provider.request({
                method: 'das_getAddressAccount',
                params: [address]
            });
            const data = res.data || [];
            return data.map(account => {
                return Object.assign(Object.assign({}, account.account_data), { avatar: `https://identicons.da.systems/identicon/${account}` });
            });
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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